module.exports = __webpack_public_path__ + "static/bg_home-e58ca5abc3731da823127b19307a0307.svg";